import {
  Box,
  Grid,
  Typography,
  Container,
  TextField,
  MenuItem,
} from "@mui/material";
import logo from "../../assets/images/Latest Logo.png";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import Footer from "./HomeFooter";
import { CiMobile3 } from "react-icons/ci";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { PiMailboxLight } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { PiBuildings } from "react-icons/pi";
import search_images from "../../assets/images/Searching.jpg";
import { styled } from "@mui/system";
import { GoLightBulb } from "react-icons/go";
import { PiMapPinSimpleLine } from "react-icons/pi";
import { IoMailOutline } from "react-icons/io5";
import { BsPhone } from "react-icons/bs";
import { RxHamburgerMenu } from "react-icons/rx";
import { PiUserLight } from "react-icons/pi";
import { useState } from "react";
import { BsGenderAmbiguous } from "react-icons/bs";
import Fade from "react-reveal/Fade";

const RoundedImage = styled("img")(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));
const ContactUs = ({ title, progress, color }) => {
  const naviagte = useNavigate();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const gender = [
    {
      value: "Male",
      label: "Male",
    },
    {
      value: "Female",
      label: "Female",
    },
    {
      value: "Other",
      label: "Other",
    },
  ];
  const fieldStyle = {
    width: "100%",
    "& .MuiInputBase-root": {
      paddingLeft: "30px", // Adjust padding to make space for the icon
    },
    "& .MuiInputLabel-root": {
      left: "35px",
      fontSize: "14px ", // Adjust label position to align with input text
    },
    "& .MuiInputBase-input": {
      paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
    },
    "& .MuiInputLabel-shrink": {
      left: "35px",
      fontSize: "14px  ", // Adjust label position when it shrinks
    },
    padding: "7px",
  };

  return (
    <Box>
        <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>

        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b style={{ marginLeft: "10px", fontSize: "16px ", fontWeight:"500" }}>Home</b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b style={{ marginLeft: "5px", fontSize: "16px ", fontWeight:"500" }}>Our Platform</b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b style={{ marginLeft: "10px", fontSize: "16px ", fontWeight:"500" }}>About us</b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b style={{ marginLeft: "10px", fontSize: "16px ", fontWeight:"500" }}>Contact us</b>
          </a>
          <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px  ",
                  fontWeight: "500",
                }}
              >
                Home
              </b>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </b>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                About us
              </b>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Contact us
              </b>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "35px" }} id="home" />
      <Fade bottom delay={200}>
        <Box className={styles.contact_details}>
          <b style={{ fontSize: "22px" }}>Contact Us</b>
        </Box>

      </Fade>
    
        <Box sx={{ margin: "0 24px 24px" }}>
        <Fade bottom delay={200}>
          <Grid container sx={{ alignSelf: "end", width: "100%" }}>
            <Grid
              item
              xs={12}
              sm={6}
              md={5}
              lg={5}
              sx={{
                padding: {
                  xs: "0 10px 0 27px",
                  sm: "0 10px 0 40px",
                  md: "0 10px 0 40px",
                },
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ marginBottom: "20px" }}>
                  <Typography
                    sx={{ marginBottom: "25px", fontSize: "20px !important" }}
                  >
                    <b>Povital Offices </b>
                  </Typography>

                  <span className={styles.profile_details_view}>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        // padding: "4px 0 4px 0",
                        marginBottom: "10px",
                      }}
                    >
                      <Typography>
                        <div
                          style={{
                            backgroundColor: "#e1eaf0",
                            cursor: "pointer",
                            borderRadius: "3px ",
                          }}
                        >
                          <PiMapPinSimpleLine
                            style={{
                              fontSize: "27px",
                              marginBottom: "2px",
                              padding: "4px 0 2px 0",
                              color: "#3e5ba8",
                            }}
                          />
                        </div>
                      </Typography>
                    </span>
                    <Typography
                      component="span"
                      sx={{
                        marginLeft: "10px",
                        fontSize: "17px !important",
                        lineHeight: "1.8",
                      }}
                    >
                      Plat No 186 B, Basanti Bagh, Tehsil Baddi, Solan,
                      <br />
                      Himanchal Pradesh, 173204
                    </Typography>
                  </span>

                  <span
                    className={styles.profile_details_view}
                    style={{ marginTop: "5px" }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        // padding: "4px 0 4px 0",
                        marginBottom: "10px",
                      }}
                    >
                      <Typography>
                        <div
                          style={{
                            backgroundColor: "#e1eaf0",
                            cursor: "pointer",
                            borderRadius: "3px ",
                          }}
                        >
                          <PiMapPinSimpleLine
                            style={{
                              fontSize: "27px",
                              marginBottom: "2px",
                              padding: "4px 0 2px 0",
                              color: "#3e5ba8",
                            }}
                          />
                        </div>
                      </Typography>
                    </span>

                    <Typography
                      component="span"
                      sx={{
                        marginLeft: "10px",
                        fontSize: "17px !important",
                        lineHeight: "1.8",
                      }}
                    >
                      Plat No 217 Rasulghar, Bomikhal Khorda,
                      <br />
                      Bhubaneswar , 754002
                    </Typography>
                  </span>
                  {/* <span
                    className={styles.profile_details_view}
                    style={{ marginTop: "5px" }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        // padding: "4px 0 4px 0",
                        marginBottom: "10px",
                      }}
                    >
                      <Typography>
                        <div
                          style={{
                            backgroundColor: "#e1eaf0",
                            cursor: "pointer",
                            borderRadius: "3px ",
                          }}
                        >
                          <PiMapPinSimpleLine
                            style={{
                              fontSize: "27px",
                              marginBottom: "2px",
                              padding: "4px 0 2px 0",
                              color: "#3e5ba8",
                            }}
                          />
                        </div>
                      </Typography>
                    </span>

                    <Typography
                      sx={{
                        marginLeft: "10px",
                        fontSize: "17px !important",
                        lineHeight: "1.8",
                      }}
                    >
                      2071 Tabasco Cat Trail Frisco, Texas 75035, US
                    </Typography>
                  </span> */}
                </span>
              </span>

              <span>
                <Typography
                  sx={{ marginBottom: "20px", fontSize: "20px !important" }}
                >
                  <b>Get in Touch </b>
                </Typography>

                <span className={styles.profile_details_view}>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // padding:'2px 0 0 2px',
                      marginBottom: "10px",
                    }}
                  >
                    <Typography>
                      <div
                        style={{
                          backgroundColor: "#e1eaf0",
                          cursor: "pointer",
                          borderRadius: "3px ",
                        }}
                      >
                        <IoMailOutline
                          style={{
                            fontSize: "27px",
                            marginBottom: "2px",
                            padding: "4px 0 2px 0",
                            color: "#3e5ba8",
                          }}
                        />
                      </div>
                    </Typography>
                  </span>
                  <Typography
                    component="span"
                    sx={{
                      marginLeft: "10px",
                      fontSize: "17px !important",
                      lineHeight: "1.8",
                    }}
                  >
                    Email: contact@povital.com
                  </Typography>
                </span>

                <span
                  className={styles.profile_details_view}
                  style={{ marginTop: "5px" }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "4px 0 4px 0",
                      marginBottom: "10px",
                      color: "#3e5ba8",
                    }}
                  >
                    <Typography>
                      <div
                        style={{
                          backgroundColor: "#e1eaf0",
                          cursor: "pointer",
                          borderRadius: "3px ",
                        }}
                      >
                        <BsPhone
                          style={{
                            fontSize: "27px",
                            marginBottom: "2px",
                            padding: "4px 0 2px 0",
                            color: "#3e5ba8",
                          }}
                        />
                      </div>
                    </Typography>
                  </span>

                  <Typography
                    sx={{
                      marginLeft: "10px",
                      fontSize: "17px !important",
                      lineHeight: "1.8",
                    }}
                  >
                    India: +91 98738 53335
                  </Typography>
                </span>
                {/* <span
                  className={styles.profile_details_view}
                  style={{ marginTop: "5px" }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // padding: "4px 0 4px 0",
                      marginBottom: "10px",
                    }}
                  >
                    <Typography>
                      <div
                        style={{
                          backgroundColor: "#e1eaf0",
                          cursor: "pointer",
                          borderRadius: "3px ",
                        }}
                      >
                        <BsPhone
                          style={{
                            fontSize: "27px",
                            marginBottom: "2px",
                            padding: "4px 0 2px 0",
                            color: "#3e5ba8",
                          }}
                        />
                      </div>
                    </Typography>
                  </span>

                  <Typography
                    sx={{
                      marginLeft: "10px",
                      fontSize: "17px !important",
                      lineHeight: "1.8",
                    }}
                  >
                    USA: +1 430 407 5520
                  </Typography>
                </span> */}
              </span>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              md={7}
              lg={7}
              sx={{ padding: "25px 10px 0 10px" }}
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px 15px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <PiUserLight
                      style={{ fontSize: "25px", color: "#3f475a" }}
                    />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Full Name"
                    variant="standard"
                    sx={fieldStyle}
                    // sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px 15px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <BsGenderAmbiguous
                      style={{ fontSize: "25px", color: "#3f475a" }}
                    />
                  </Box>
                  <TextField
                    select
                    variant="standard"
                    label="Gender"
                    sx={fieldStyle}
                  >
                    {gender.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px 15px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="Phone No"
                    variant="standard"
                    sx={fieldStyle}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ padding: "10px 15px", position: "relative" }}
                >
                  <Box className={styles.icon_style}>
                    <PiMailboxLight
                      style={{ fontSize: "25px", color: "#3f475a" }}
                    />
                  </Box>
                  <TextField
                    id="standard-basic"
                    label="E-Mail ID"
                    variant="standard"
                    type="text"
                    sx={fieldStyle}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "10px 15px", position: "relative" }}
                >
                  <TextField
                    variant="outlined"
                    multiline
                    rows={7}
                    placeholder="Write Message"
                    sx={{
                      width: "100%",
                      margin: "10px 0",
                      backgroundColor: "#fff",
                    }}
                  />
                </Grid>
                <Box className={styles.send_btn}>
                  <button>Send Now</button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          </Fade>
        </Box>
    

      <Footer />
    </Box>
  );
};

export default ContactUs;
